<script setup lang="ts">
import { Tint } from "~/components/clarity-ui/Tint";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

export interface BackButtonProps {
  customClick?: () => void;
  to?: string;
}

const { to } = defineProps<BackButtonProps>();
const router = useRouter();

const onClick = async () => {
  if (to) {
    await navigateTo(to);
  } else {
    router.go(-1);
  }
};
</script>

<template>
  <Tint class="text-icon-link" tag="div" @click="customClick ? null : onClick()">
    <SvgIcon class="h-4 w-4 -rotate-90" name="Arrow-Up" />
    <CommonLabel path="BWF/shared/back" />
  </Tint>
</template>
